<template>
  <div class="loading" v-if="loading">
    <v-icon>mdi-circle</v-icon>
    <v-icon>mdi-circle</v-icon>
    <v-icon>mdi-circle</v-icon>
  </div>
  <div class="table" v-else="!loading">
  <div class="left-col">
    <div class="box">
      <div class="row open-category">
        <span v-if="!categoryOpen" @click="categoryOpen = !categoryOpen">показать категории</span>
        <span v-if="categoryOpen" @click="categoryOpen = !categoryOpen">скрыть категории</span>
      </div>
      <div class="row"  v-if="categoryOpen">
        <div class="header col-lg-4 col-6 diff bg-transparent"><div>Категории</div> <div class="header-check">стопы<v-checkbox type="checkbox" v-model="offCat"></v-checkbox></div></div>
      </div>
      <div class="row" v-if="categoryOpen">
        <div class="col-lg-4 col-6 diff">
          <strong>Название блюда</strong>
          <strong>На стопе в филиалах</strong>
        </div>
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
        <div class="col-lg-4 col-6 diff">
            <strong>name</strong>
            <strong>На стопе в филиалах</strong>
        </div>
        <div class="col-lg-4 col-6 diff" v-for="category in categories.filter(item => !offCat || getCatIsOnStop(item.id))">
          <div :class="'label' + (getCatIsOnStop(category.id) ? ' label-stop' : '')">{{category.name}}</div>
          <div class="selectable">
            <div class="select-list">
              <div :class="isSelected(category.id, branch, true) ? 'select selected' : 'select'" v-for="branch of branches" @click="toggleStop(category.id, branch, true)">{{branch.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="row open-category">
        <span v-if="!workshopOpen" @click="workshopOpen = !workshopOpen">показать цеха</span>
        <span v-if="workshopOpen" @click="workshopOpen = !workshopOpen">скрыть цеха</span>
      </div>
      <div class="row"  v-if="workshopOpen">
        <div class="header col-lg-4 col-6 diff bg-transparent"><div>Цеха</div> <div class="header-check">стопы<v-checkbox type="checkbox" v-model="offWs"></v-checkbox></div></div>
      </div>
      <div class="row" v-if="workshopOpen">
        <div class="col-lg-4 col-6 diff">
          <strong>Название цеха</strong>
          <strong>На стопе в филиалах</strong>
        </div>
        <div class="col-lg-4 col-6 diff">
          <strong>Название цеха</strong>
          <strong>На стопе в филиалах</strong>
        </div>
        <div class="col-lg-4 col-6 diff">
          <strong>Название цеха</strong>
          <strong>На стопе в филиалах</strong>
        </div>
        <div class="col-lg-4 col-6 diff" v-for="workshop in workshops.filter(item => !offWs || getWsIsOnStop(item.id))">
          <div :class="'label' + (getWsIsOnStop(workshop.id) ? ' label-stop' : '')">{{workshop.name}}</div>
          <div class="selectable">
            <div class="select-list">
              <div :class="isSelected(workshop.id, branch, false, true) ? 'select selected' : 'select'" v-for="branch of branches" @click="toggleStop(workshop.id, branch, false, true)">{{branch.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="row">
        <div class=" col-lg-4 col-6">
          <div class="header diff bg-transparent">
            <div>Блюда (стоп только в Glovo)</div>
            <div class="header-check">стопы<v-checkbox type="checkbox" v-model="offProd"></v-checkbox></div>
          </div>
          <div class="diff bg-transparent">
            <div>поиск по категориям:</div>
            <v-autocomplete
                class="category-search"
                v-model="categoriesFilter"
                :items="categories"
                hide-no-data
                multiple
                item-text="name"
                item-value="id"
                return-object
            ></v-autocomplete>
          </div>
        </div>
        <div class="col-lg-8 col-6 diff bg-transparent">
          <div v-if="updating">сохраняю...</div>
          <div v-if="!updating"></div>
          <v-text-field
              v-model="filter"
              append-icon="mdi-magnify"
          ></v-text-field>
        </div>
      </div>
        <div class="row">
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
          <div class="col-lg-4 col-6 diff" v-for="product in products.filter(filteredProduct)">
            <div class="label-cnt">
              <div :class="'label' + (getIsOnStop(product)? ' label-stop' : '')">{{product.name}}</div>
              <div class="label-desc">{{product.cname}}</div>
            </div>
            <div class="selectable">
              <div class="selectable-column">
                <div class="select-list">
                  <div :class="isSelected(product.id, branch) ? 'select selected' : 'select'" v-for="branch of branches" @click="toggleStop(product.id, branch)">{{branch.name}}</div>
                </div>
                <div class="hint" v-if="getFromCategory(product)">
                  категория "{{getCategoryName(product)}}" на стопе в : {{getFromCategory(product)}}
                </div>
                <div class="hint" v-if="getFromWorkshop(product)">
                  цех "{{getWorkshopName(product)}}" на стопе в : {{getFromWorkshop(product)}}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!products.filter(filteredProduct).length" class="nothing col-12">Нет таких товаров</div>
        </div>
    </div>
  </div>
    <div class="right-col">
    </div>
  </div>
</template>

<script>
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from "vue";

export default {
  name: 'StopsGlovo',
  props: {},
  components: {},
  filters: {},
  data: () => ({
    loading: 0,
    categories: [],
    categoriesFilter: [],
    branches: [],
    products: [],
    workshops: [],
    valuesCat: {},
    valuesProd: {},
    valuesWs: {},
    filter: '',
    updating: 0,
    offCat: false,
    offWs: false,
    offProd: true,
    updateKey: 0,
    categoryOpen: false,
    workshopOpen: false,
  }),
  mounted() {
    this.loading = 4;

    Vue.axios.get('/branches?for_stops=1').then((resB) => {
      this.branches = resB.data
          .map(({id, name}) => ({id, name}));

      for (const branch of resB.data) {
        const glovoDisabledItems = JSON.parse( branch.glovo_disabled_items || '{}' );
        const {products = [], categories = [], workshops = []} = glovoDisabledItems || {};

        for (const catId of categories) {
          if (!this.valuesCat[catId]) this.valuesCat[catId] = [];
          this.valuesCat[catId].push({id: branch.id, name: branch.name});
        }

        for (const wsId of workshops) {
          if (!this.valuesWs[wsId]) this.valuesWs[wsId] = [];
          this.valuesWs[wsId].push({id: branch.id, name: branch.name});
        }

        for (const productId of products) {
          if (!this.valuesProd[productId]) this.valuesProd[productId] = [];
          this.valuesProd[productId].push({id: branch.id, name: branch.name});
        }
      }

      Vue.axios.get('/product/categories').then((res) => {
        let categoriesMap = {};
        this.categories = res.data
            .map(({id, name}) => ({id, name}))
            .sort((item1, item2) => item1.name.localeCompare(item2.name));

        for (let category of this.categories) {
          categoriesMap[category.id] = category.name;
        }

        Vue.axios.get('/products?forList=1').then((res) => {
          this.products = res.data
              .map(({id, name, category_id = 0, workshop_id = 0}) => ({id, name, cid: category_id, wsid: workshop_id, cname: categoriesMap[category_id]}))
              .sort((item1, item2) => item1.name.localeCompare(item2.name));
          this.loading--;
        }).catch((err) => {
          console.error(err);
          this.loading--;
        });

        this.loading--;
      }).catch((err) => {
        console.error(err);
        this.loading--;
      });
      this.loading--;
    }).catch((err) => {
      console.error(err);
      this.loading--;
    });

    Vue.axios.get('/workshops').then((res) => {
      this.workshops = res.data
          .map(({id, name}) => ({id, name}))
          .sort((item1, item2) => item1.name.localeCompare(item2.name));
      this.loading--;
    }).catch((err) => {
      console.error(err);
      this.loading--;
    });

  },
  watch: {},
  methods: {
    filteredProduct(product) {
      if (this.filter.length) {
        return product.name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
      }

      if (!this.offProd || this.getIsOnStop(product)) {
        if (this.categoriesFilter.length && !this.categoriesFilter.find(category => category.id === product.cid)) {
          return false;
        }
        return true;
      }

      return false;
    },
    async toggleStop(cntId, branch, isCategory = false, isWorkshop = false) {
      const where = isCategory ? this.valuesCat : (isWorkshop ? this.valuesWs : this.valuesProd);
      if (!where[cntId]) {
        where[cntId] = [];
      }

      if (where[cntId].find(item => item.id === branch.id)) {
        where[cntId] = where[cntId].filter(item => item.id !== branch.id);
      } else {
        where[cntId].push(branch);
      }

      this.updateKey++;

      await this.update();
    },
    isSelected(cntId, branch, isCategory = false, isWorkshop = false) {
      const where = isCategory ? this.valuesCat : (isWorkshop ? this.valuesWs : this.valuesProd);
      if (!where[cntId]) {
        where[cntId] = [];
      }
      return !!where[cntId].find(item => item.id === branch.id);
    },
    getCatIsOnStop(categoryId) {
      return this.valuesCat[categoryId] && this.valuesCat[categoryId].length;
    },
    getWsIsOnStop(workshopId) {
      return this.valuesWs[workshopId] && this.valuesWs[workshopId].length;
    },
    getIsOnStop(product) {
      return this.valuesProd[product.id] && this.valuesProd[product.id].length || this.getCatIsOnStop(product.cid) || (product.wsid && this.getWsIsOnStop(product.wsid));
    },
    getFromCategory(product) {
      const cat = this.valuesCat[product.cid];
      if (cat && cat.length) {
        return this.branches.filter(branch => cat.find(category => category.id === branch.id))
            .map(branch => branch.name)
            .join(', ');
      }
      return '';
    },
    getFromWorkshop(product) {
      const ws = this.valuesWs[product.wsid];
      if (ws && ws.length) {
        return this.branches.filter(branch => ws.find(workshop => workshop.id === branch.id))
            .map(branch => branch.name)
            .join(', ');
      }
      return '';
    },
    getCategoryName(product) {
      const cat = this.categories.find(item => item.id === product.cid);
      if (cat) {
        return cat.name;
      }
      return 'Неизвестная Категория';
    },
    getWorkshopName(product) {
      const ws = this.workshops.find(item => item.id === product.wsid);
      if (ws) {
        return ws.name;
      }
      return 'Неизвестный Цех';
    },
    async update() {
      const branchProducts = {};
      const branchCategories = {};
      const branchWorkshops = {};
      for (const branch of this.branches) {
        branchProducts[branch.id] = [];
        branchCategories[branch.id] = [];
        branchWorkshops[branch.id] = [];
      }

      const catIds = Object.keys(this.valuesCat);
      for (const id of catIds) {
        for (const branch of this.valuesCat[id]) {
          branchCategories[branch.id].push(id);
        }
      }

      const wsIds = Object.keys(this.valuesWs);
      for (const id of wsIds) {
        for (const branch of this.valuesWs[id]) {
          branchWorkshops[branch.id].push(id);
        }
      }

      const prodIds = Object.keys(this.valuesProd);
      for (const id of prodIds) {
        for (const branch of this.valuesProd[id]) {
          branchProducts[branch.id].push(id);
        }
      }

      this.updating = this.branches.length;

      for (const branch of this.branches) {
        this.updating--;
        await Vue.axios.post('/branches/update-glovo-only', {
          branch_id: branch.id,
          products: branchProducts[branch.id],
          categories: branchCategories[branch.id],
          workshops: branchWorkshops[branch.id],
        }).catch((err) => {
          console.error(err);
        });
      }
    }
  },
}
</script>

<style scoped lang="scss">
.loading {
  display: flex;
  min-height: 100dvh;
  justify-content: center;
  align-items: center;
}
.table {
  width: 100%;
  .left-col {
    .header-check {
      font-size: 16px;
      font-weight: 300;
      display: flex;
    }
    .header {
      font-size: 24px;
      color: #333;
      font-family: monospace, sans-serif;
      display: flex;
      align-items: center;
      .add {
        margin-left: auto;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
      }
    }
    .box + .box {
      margin-top: 30px;
    }
  }
}
.diff {
  display: flex;
  border-bottom: 2px solid silver;
  &:nth-child(3n + 1), &:nth-child(3n + 2) {
    border-right: 1px solid silver;
  }
  &:nth-child(6n + 1), &:nth-child(6n + 2), &:nth-child(6n + 3) {
    background-color: #eee;
  }
  > :nth-child(1) {
    flex-grow: 1;
    padding-right: 20px;
  }
  > :nth-child(2) {
    flex-grow: 0;
    margin-left: auto;
  }
}
.selectable {
  width: 250px;
  .v-select {
    padding-top: 0;
    margin-top: 0;
  }
  .selectable-column {
    display: flex;
    flex-direction: column;
  }
  .hint {
    margin-top: 10px;
    color: #333;
    font-size: 12px;
    text-align: right;
  }
}
.bg-transparent {
  background-color: transparent !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  .v-input {
    padding: 0;
    margin-top: 0;
  }
  .v-input__append-inner {
    margin-top: 12px;
  }
}
.label-cnt {
  display: flex;
  flex-direction: column;
}
.label-desc {
  margin-top: auto;
}
.label-stop {
  color: darkred;
}
.open-category {
  display: block;
  text-align: right;
  span {
    color: #777;
    text-decoration: underline;
    cursor: pointer;
    user-select: none;
  }
}
.select-list {
  width: 250px;
  display: flex;
  flex-wrap: wrap;
  .select {
    border: 1px solid #333;
    background-color: #eee;
    text-align: center;
    box-shadow: 1px 1px 10px grey;
    color: #333;
    cursor: pointer;
    user-select: none;
    width: 45%;
    margin-bottom: 10px;
    border-radius: 5px;
    &:nth-child(2n) {
      margin-left: auto;
    }
    &.selected {
      color: darkred;
      border: 1px solid darkred;
    }
  }
}
.category-search {
  flex-grow: 1 !important;
  margin-left: 10px;
}
.nothing {
  text-align: center;
  color: #333;
  padding: 5px 10px;
}
</style>
